export const DEFAULT_TIMEZONE: string = 'Europe/Madrid';

export const DATE_FORMAT_SHORT_TIME = 'HH:mm';
export const DATE_FORMAT_LONG_DATE = 'LL';
export const DATE_FORMAT_LONG_DATE_WITH_TIME = 'LLL';
export const DATE_FORMAT_SHORT_DATE_WITH_TIME = 'DD/MM/YYYY - HH:mm';
export const DATE_FORMAT_DAY_NUMBER = 'D';
export const DATE_FORMAT_DAY_TWO_NUMBER = 'DD';
export const DATE_FORMAT_DAY_LETTER = 'dd';
export const DATE_FORMAT_LONG_DAY_LETTER = 'ddd';
export const DATE_FORMAT_SHORT_MONTH = 'MMM';
export const DATE_FORMAT_SHORT_YEAR = 'YY';
export const DATE_FORMAT_MONTH_WITH_YEAR = 'MMMM YY';
export const DATE_FORMAT_DAY_WITH_NUMBER = 'ddd DD';
export const DATE_FORMAT_DAY_WITH_NUMBER_MONTH = 'ddd DD MMM';
export const DATE_FORMAT_DAY_WITH_NUMBER_HOUR = 'ddd DD HH:mm';
export const DATE_FORMAT_LONG_DATE_FULL_YEAR = 'ddd MMM YYYY';
export const DATE_FORMAT_SHORT_DATE = 'DD_MM_YY';
export const DATE_FORMAT_SHORT_DATE_SHORT_YEAR = 'DD MMM YY';
export const DATE_FORMAT_SHORT_DATE_HOUR = 'DD MMM HH:mm';
export const DATE_FORMAT_SHORT_DAY_MONTH_HOUR = ' MMM Do, HH:mm';
export const DATE_FORMAT_DAY_MONTH_YEAR = 'ddd, MMMM D, YYYY';
